module.exports = __webpack_public_path__ + "static/img/16.9b2602e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/16.png
// module id = YnvZ
// module chunks = 0